const linkGroups = [
  {
    title: '逛瓜专区',
    items: [
      { label: '实时热门爆料', href: '#feed' },
      { label: '今日热度榜', href: '#hot' },
      { label: '栏目专区', href: '#columns' },
      { label: '真香现场', href: '#real' },
    ],
  },
  {
    title: '找点帮助',
    items: [
      { label: '常见问题', href: '#faq' },
      { label: '瓜友口碑', href: '#voice' },
      { label: '投稿征集', href: '#submit' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-white">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-400 text-lg">
                🍉
              </span>
              <span className="font-display text-xl">吃瓜cb</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-white/75">
              吃瓜cb是一个主打「边吃边看」的娱乐资讯门户，热门爆料实时更新、栏目清晰、轻松下饭。无论早八通勤还是深夜放空，都能在吃瓜cb找到配饭的好内容，开动好奇心，边吃边看真香现场。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-white/80">
              <i className="ri-mail-line"></i>
              合作与投稿：submit@chiguacb.com
            </p>
          </div>

          {linkGroups.map((g) => (
            <div key={g.title}>
              <h4 className="font-display text-lg text-accent-300">{g.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {g.items.map((it) => (
                  <li key={it.href + it.label}>
                    <a
                      href={it.href}
                      className="inline-flex items-center gap-2 text-sm text-white/80 transition-colors hover:text-accent-300"
                    >
                      <i className="ri-arrow-right-s-line text-white/40"></i>
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/15 pt-5 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between">
          <p>
            <i className="ri-information-line mr-1"></i>
            内容基于公开信息整理，倡导理性吃瓜、不信谣不传谣。如涉及侵权请联系我们处理。
          </p>
          <p className="whitespace-nowrap">© 2026 吃瓜cb · 配饭下饭两不误，边吃边看更带劲</p>
        </div>
      </div>
    </footer>
  );
}